module.exports = __webpack_public_path__ + "img/zk-icon-activity.ee76aca0.svg";